(function(){
  'use strict';
  var container = document.getElementById('menu-bar-container');
  if (!container) return;

  var isListingsPage = window.location.pathname === '/obyavleniya';

  container.innerHTML = `    <div class="menu-bar position-left" id="menu-bar">
        <div class="menu-items">
            <button class="menu-item" data-panel="layers" aria-label="Слои карты" title="Слои карты">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" stroke-width="1.5" d="M4.979 9.685C2.993 8.891 2 8.494 2 8s.993-.89 2.979-1.685l2.808-1.123C9.773 4.397 10.767 4 12 4s2.227.397 4.213 1.192l2.808 1.123C21.007 7.109 22 7.506 22 8s-.993.89-2.979 1.685l-2.808 1.124C14.227 11.603 13.233 12 12 12s-2.227-.397-4.213-1.191z"/>
    <path stroke="currentColor" stroke-width="1.5" d="m5.766 10-.787.315C2.993 11.109 2 11.507 2 12s.993.89 2.979 1.685l2.808 1.124C9.773 15.603 10.767 16 12 16s2.227-.397 4.213-1.191l2.808-1.124C21.007 12.891 22 12.493 22 12s-.993-.89-2.979-1.685L18.234 10"/>
    <path stroke="currentColor" stroke-width="1.5" d="m5.766 14-.787.315C2.993 15.109 2 15.507 2 16s.993.89 2.979 1.685l2.808 1.124C9.773 19.603 10.767 20 12 20s2.227-.397 4.213-1.192l2.808-1.123C21.007 16.891 22 16.494 22 16c0-.493-.993-.89-2.979-1.685L18.234 14"/>
</svg>
            </button>
            <button class="menu-item" id="menu-filters-btn" data-auth="filters" data-panel="filters" aria-label="Фильтры" title="Фильтры">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" stroke-width="1.5" d="M19 3H5c-1.414 0-2.121 0-2.56.412S2 4.488 2 5.815v.69c0 1.037 0 1.556.26 1.986s.733.698 1.682 1.232l2.913 1.64c.636.358.955.537 1.183.735.474.411.766.895.898 1.49.064.284.064.618.064 1.285v2.67c0 .909 0 1.364.252 1.718.252.355.7.53 1.594.88 1.879.734 2.818 1.101 3.486.683S15 19.452 15 17.542v-2.67c0-.666 0-1 .064-1.285a2.68 2.68 0 0 1 .899-1.49c.227-.197.546-.376 1.182-.735l2.913-1.64c.948-.533 1.423-.8 1.682-1.23.26-.43.26-.95.26-1.988v-.69c0-1.326 0-1.99-.44-2.402C21.122 3 20.415 3 19 3Z"/>
</svg>
            </button>
            <button class="menu-item" id="menu-my-ads-btn" data-auth="my-ads" data-panel="my-ads" data-admin-only style="display:none" aria-label="Мои объявления" title="Мои объявления">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
    <rect x="9" y="3" width="6" height="4" rx="2"/>
    <path d="M9 12h.01"/><path d="M13 12h2"/><path d="M9 16h.01"/><path d="M13 16h2"/>
</svg>
            </button>
            <button class="menu-item" id="menu-favorites-btn" data-auth="favorites" data-panel="favorites" aria-label="Избранное" title="Избранное">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" stroke-width="1.5" d="M9.153 5.408C10.42 3.136 11.053 2 12 2s1.58 1.136 2.847 3.408l.328.588c.36.646.54.969.82 1.182s.63.292 1.33.45l.636.144c2.46.557 3.689.835 3.982 1.776.292.94-.546 1.921-2.223 3.882l-.434.507c-.476.557-.715.836-.822 1.18-.107.345-.071.717.001 1.46l.066.677c.253 2.617.38 3.925-.386 4.506s-1.918.051-4.22-1.009l-.597-.274c-.654-.302-.981-.452-1.328-.452s-.674.15-1.328.452l-.596.274c-2.303 1.06-3.455 1.59-4.22 1.01-.767-.582-.64-1.89-.387-4.507l.066-.676c.072-.744.108-1.116 0-1.46-.106-.345-.345-.624-.821-1.18l-.434-.508c-1.677-1.96-2.515-2.941-2.223-3.882S3.58 8.328 6.04 7.772l.636-.144c.699-.158 1.048-.237 1.329-.45s.46-.536.82-1.182z"/>
</svg>
            </button>
            <a class="menu-item" id="menu-listings-btn" href="/obyavleniya" aria-label="Объявления" title="Объявления">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
    <rect x="9" y="3" width="6" height="4" rx="2"/>
    <path d="M9 12h.01"/><path d="M13 12h2"/><path d="M9 16h.01"/><path d="M13 16h2"/>
</svg>
            </a>
            <button class="menu-item" data-panel="info" aria-label="Информация" title="Информация">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M12 17v-6"/>
    <circle cx="1" cy="1" r="1" fill="currentColor" transform="matrix(1 0 0 -1 11 9)"/>
    <path stroke="currentColor" stroke-width="1.5" d="M2 12c0-4.714 0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464C22 4.93 22 7.286 22 12s0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12Z"/>
</svg>
            </button>
            <button class="menu-item" data-toggle="themes" aria-label="Темы оформления" title="Темы оформления">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/>
    <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/>
    <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/>
    <circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/>
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.01 17.461 2 12 2z"/>
</svg>
            </button>
        </div>
        <button class="menu-item" id="menu-profile-btn" data-auth="profile" aria-label="Профиль" title="Профиль">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="8" r="4"/>
    <path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
</svg>
        </button>
    </div>

    <!-- Layers Menu -->
    <div class="menu-bar-secondary" id="layers-secondary-menu">
        <button class="menu-item-secondary" data-layer="2gis" title="2GIS">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/2gis.png" alt="2GIS">
        </button>
        <button class="menu-item-secondary" data-layer="yandex" title="Яндекс Карты">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/yandex_karti.png" alt="Яндекс Карты">
        </button>
        <button class="menu-item-secondary" data-layer="google" title="Google Карты">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/google.png" alt="Google Карты">
        </button>
        <button class="menu-item-secondary" data-layer="cartodb" title="CartoDB Light">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/cartodb.png" alt="CartoDB Light">
        </button>
        <button class="menu-item-secondary active" data-layer="osm" title="OpenStreetMap">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/openstreetmap.png" alt="OpenStreetMap">
        </button>
        <button class="menu-item-secondary" data-layer="yandex-sat" title="Яндекс Спутник">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/yandex_sputnik.png" alt="Яндекс Спутник">
        </button>
        <button class="menu-item-secondary" data-layer="google-sat" title="Google Спутник">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/google_sat.png" alt="Google Спутник">
        </button>
        <button class="menu-item-secondary" data-layer="satellite" title="Спутник ESRI">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/sputnik_ersi.png" alt="Спутник ESRI">
        </button>
        <button class="menu-item-secondary" data-layer="nspd" title="НСПД">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/nspd.png" alt="НСПД">
        </button>
        <button class="menu-item-secondary" data-layer="digimap" title="Digimap">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/digimap.png" alt="Digimap">
        </button>
        <button class="menu-item-secondary" data-layer="waze" title="Waze">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/waze.png" alt="Waze">
        </button>
        <button class="menu-item-secondary" data-layer="bing" title="Bing Карты">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/bing.png" alt="Bing Карты">
        </button>
        <button class="menu-item-secondary" data-layer="bing-sat" title="Bing Спутник">
            <img class="layer-thumb" loading="lazy" decoding="async" src="/assets/icons_maps/bing_sat.png" alt="Bing Спутник">
        </button>
        <button class="menu-item-secondary" data-layer="polygons" title="Границы участков">
            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="22" height="22">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 6l9-4 9 4v12l-9 4-9-4V6z"/>
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 22V10"/>
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 10L21 6"/>
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 10L3 6"/>
            </svg>
        </button>
        <button class="menu-item-secondary" data-layer="mapru-zu" title="Map.ru Земельные участки">
            <svg viewBox="0 0 24 24" width="22" height="22">
                <rect x="3" y="3" width="18" height="18" rx="3" fill="#27ae60" opacity="0.85"/>
                <text x="12" y="16" text-anchor="middle" fill="#fff" font-size="9" font-weight="bold">ЗУ</text>
            </svg>
        </button>
        <button class="menu-item-secondary" data-layer="mapru-oks" title="Map.ru Здания">
            <svg viewBox="0 0 24 24" width="22" height="22">
                <rect x="3" y="3" width="18" height="18" rx="3" fill="#2980b9" opacity="0.85"/>
                <text x="12" y="16" text-anchor="middle" fill="#fff" font-size="8" font-weight="bold">ОКС</text>
            </svg>
        </button>
        <button class="menu-item-secondary" data-layer="mapru-ons" title="Map.ru ОНС">
            <svg viewBox="0 0 24 24" width="22" height="22">
                <rect x="3" y="3" width="18" height="18" rx="3" fill="#e67e22" opacity="0.85"/>
                <text x="12" y="16" text-anchor="middle" fill="#fff" font-size="8" font-weight="bold">ОНС</text>
            </svg>
        </button>
        <button class="menu-item-secondary" data-action="toggle-3d" title="3D вид (рельеф + объёмные участки)">
            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
    <path d="M21 16.5a9.96 9.96 0 0 1-5.7 3.7M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9"/>
    <path d="M12 3v18M3 12h18"/>
</svg>
        </button>
    </div>

    <!-- Themes Menu -->
    <div class="menu-bar-secondary" id="themes-secondary-menu">
        <button class="theme-toggle-btn active" data-theme="v1" onclick="setTheme('v1')" title="1 Стандарт">1</button>
        <button class="theme-toggle-btn" data-theme="v2" onclick="setTheme('v2')" title="2 Деловой">2</button>
        <button class="theme-toggle-btn" data-theme="v9" onclick="setTheme('v9')" title="9 Terminal Dark">9</button>
        <button class="theme-toggle-btn" data-theme="v14" onclick="setTheme('v14')" title="14 Terminal Amber">14</button>
        <button class="theme-toggle-btn" data-theme="v19" onclick="setTheme('v19')" title="19 Nordic">19</button>
        <button class="theme-toggle-btn" data-theme="v20" onclick="setTheme('v20')" title="20 Forest">20</button>
        <button class="theme-toggle-btn" data-theme="v21" onclick="setTheme('v21')" title="21 Noir">21</button>
        <button class="theme-toggle-btn" data-theme="v22" onclick="setTheme('v22')" title="22 Sunset">22</button>
        <button class="theme-toggle-btn" data-theme="v23" onclick="setTheme('v23')" title="23 Arctic">23</button>
    </div>
`;

  // On the listings page the listings button should lead back home and be highlighted.
  var listingsBtn = document.getElementById('menu-listings-btn');
  if (listingsBtn && isListingsPage) {
    listingsBtn.href = '/';
    listingsBtn.classList.add('active');
  }
})();
